import { css } from '@emotion/react';

import { theme } from '../../../theme';

export const styles = {
  paymentWrapper: css`
    border-radius: ${theme.borders.radius.sm};
    margin-bottom: ${theme.spacing.sm};
    display: flex;
    flex-direction: column;
    background-color: ${theme.colors.background.container};
    padding: ${theme.spacing.md};
  `,
  confirmationPageContainer: css`
    max-width: 1200px;
    padding: 0 ${theme.spacing.lg} ${theme.spacing.lg} ${theme.spacing.lg};
    margin-right: auto;
    margin-left: auto;
    display: block;
  `,
  headerContainer: css`
    margin-top: ${theme.spacing.xxxl};
    margin-bottom: ${theme.spacing.lg};
    display: flex;
    flex-direction: column;
    align-items: center;
    > h1 {
      margin: ${theme.spacing.md};
    }
    @media (max-width: ${theme.breakpoints.tablet}) {
      > p {
        text-align: center;
      }
      > h1 {
        text-align: center;
      }
    }
  `,
  infoBox: css`
    border-radius: ${theme.borders.radius.sm};
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: ${theme.spacing.sm};
    background-color: ${theme.colors.background.container};
    padding: ${theme.spacing.md};
    gap: ${theme.spacing.md};
    > div {
      > p {
        margin: 0px;
        font-size: ${theme.fontSize.md};
      }
    }
    @media (max-width: ${theme.breakpoints.laptop}) {
      > a {
        > button {
          font-size: ${theme.fontSize.sm};
        }
      }
    }
    @media (max-width: ${theme.breakpoints.tablet}) {
      flex-direction: column;
      align-items: center;
    }
  `,

  priceListWrapper: css`
    display: flex;
    justify-content: space-between;
    width: 100%;
    @media (max-width: ${theme.breakpoints.laptop}) {
      flex-direction: column;
    }
  `,
  amountsContainer: css`
    min-width: 50%;
    display: flex;
    flex-direction: column;
    > p {
      margin: 0px;
      > div {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
      }
    }
    @media (max-width: ${theme.breakpoints.laptop}) {
      min-width: 100%;
      margin-bottom: ${theme.spacing.md};
    }
  `,

  totalPriceContainer: css`
    min-width: 50%;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-end;
    gap: ${theme.spacing.sm};
    > h2 {
      margin: 0;
      color: ${theme.colors.text};
    }
    @media (max-width: ${theme.breakpoints.laptop}) {
      min-width: 100%;
      margin-top: ${theme.spacing.md};
    }
  `,
  divider: css`
    margin-top: ${theme.spacing.md};
    margin-bottom: ${theme.spacing.md};
  `,
  flightDetailsWrapper: css`
    border-radius: ${theme.borders.radius.sm};
    padding: ${theme.spacing.md};
    background-color: ${theme.colors.background.container};
  `,
  priceItemWrapper: css`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  `,
  amountsContainerSkeleton: css`
    width: 100%;
    display: flex;
    flex-direction: column;
    > p {
      margin: 0px;
      > div {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
      }
    }
    @media (max-width: ${theme.breakpoints.laptop}) {
      min-width: 100%;
      margin-bottom: ${theme.spacing.md};
    }
  `,
  totalContainer: css`
    display: flex;
    align-items: end;
    justify-content: end;
    width: 50%;
    flex-direction: column;
  `,
};
